import MemberCards from "../features/memberCards/MemberCards";

export default function MemberCardsPage() {
  return <MemberCards />;
}
